import React, { useEffect, useContext, useState } from 'react';
import Modal from 'react-modal';
import { Link } from 'react-router-dom';
import classes from './MenuSectionDropdown.module.scss';
import selectedIcon from '../../../images/icon-selected.png';
import { GeneralContext } from '../../../context/generalContext';
import { MenuContext } from '../../../context/menuContext';
import { addressesAPI } from '../../../services/GeneralService';
import closeIcon from '../../../images/icon-close.png';

Modal.setAppElement('#root');

export default function MenuSectionDropdown({
  anyDrinks,
  isOpen,
  setIsOpen,
  title,
  listItems,
  changeSelectedItem,
  selectedItem,
}) {
  const { activeLanguage, selectedAddress } = useContext(GeneralContext);
  const { menuSectionTypes, selectedMenuSectionType, setSelectedMenuSectionType } = useContext(MenuContext);
  const { data: addresses } = addressesAPI.useFetchAllAddressesQuery();

  // заморозить область за модальным если оно открыто
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
    } else {
      document.body.style.overflow = 'visible';
      document.body.style.position = '';
    }
  }, [isOpen]);

  // -----для свайпа------:
  const [isFixed, setIsFixed] = useState(false);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  const onTouchStart = e => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientY);
  };

  const onTouchMove = e => setTouchEnd(e.targetTouches[0].clientY);

  let distance;
  const onTouchEnd = () => {
    const minSwipeDistance = 2;
    if (!touchStart || !touchEnd) return;
    distance = -touchEnd + touchStart;
    const isUpSwipe = distance > minSwipeDistance;

    if (isUpSwipe) {
      moveUp();
    }
  };

  const moveUp = () => {
    const block = document.getElementById('MenuSectionDropdown');
    const list = document.getElementById('MenuSectionsModallist');

    if (block.style.top !== '0') {
      const oldHeight = Number(block.style.top.slice(0, -2));
      if (oldHeight - distance <= 0) {
        // проверяем насколько уже сдвинут блок
        block.style.top = `0`;
        list.style.overflowY = 'scroll';
        setIsFixed(true);
      } else {
        block.style.top = `${oldHeight - distance}px`;
      }
    }
  };

  const closeModal = () => {
    setIsOpen(false);
    setIsFixed(false);
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      contentLabel='My dialog'
      className={isFixed ? classes.modalFixed : classes.modal}
      overlayClassName={classes.overlay}
      id='MenuSectionDropdown'
      style={{ content: { top: '30vh' } }}
      closeTimeoutMS={300}
    >
      <div className={classes.modalDiv} onTouchStart={onTouchStart} onTouchMove={onTouchMove} onTouchEnd={onTouchEnd}>
        <div className={classes.titleDiv}>
          {anyDrinks ? (
            <>
              {menuSectionTypes.map(menuSection => (
                <p
                  key={menuSection.id}
                  className={menuSection.id === selectedMenuSectionType ? classes.titleActive : classes.title}
                  onClick={() => setSelectedMenuSectionType(menuSection.id)}
                >
                  {activeLanguage === 1 ? menuSection.name : menuSection.name_en}
                </p>
              ))}
            </>
          ) : (
            <div className={classes.titleBig}>{title}</div>
          )}
        </div>
        <div className={isFixed ? classes.closeIcon : classes.disabled} onClick={() => closeModal()}>
          <img src={closeIcon} alt='close icon' />
        </div>
        <div className={classes.list} id='MenuSectionsModallist' style={{ maxHeight: `90%`, overflowY: 'hidden' }}>
          {listItems.map(item => (
            <Link
              to={
                activeLanguage === 1
                  ? window.location.pathname.split('/').slice(-2).slice(0, 1)[0] === 'menu'
                    ? `/menu/${item.slug}`
                    : `/menu/${item.slug}/${addresses?.filter(address => address.id === selectedAddress)[0]?.slug}`
                  : window.location.pathname.split('/').slice(-2).slice(0, 1)[0] === 'menu'
                    ? `/en/menu/${item.slug}`
                    : `/en/menu/${item.slug}/${addresses?.filter(address => address.id === selectedAddress)[0]?.slug}`
              }
              key={item.id}
              className={`${classes.listItem} ${selectedItem === item.id ? `${classes.listItemActive}` : ''}`}
              onClick={() => {
                closeModal();
                changeSelectedItem(item.id);
              }}
            >
              {item.shortDescr ? (
                <p>{activeLanguage === 1 ? item.shortDescr : item.shortDescr_en || item.shortDescr}</p>
              ) : (
                <p>{activeLanguage === 1 ? item.name : item.name_en || item.name}</p>
              )}
              <img src={selectedIcon} alt='selected icon' />
            </Link>
          ))}
        </div>
      </div>
    </Modal>
  );
}
